export default __webpack_public_path__ + "static/media/stackholder3.b88ec031.png";